export default __webpack_public_path__ + "d1a464b62192de2ad31f56af9d83ee6d.png";